import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "@/lib/api";

export default function CMSPage() {
  const { slug } = useParams();
  const [page, setPage] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    let active = true;

    const loadPage = async () => {
      try {
        setLoading(true);
        setError("");

        const response = await api.get(`/pages/${slug}`);

        if (active) {
          setPage(response.data);
        }
      } catch (err) {
        if (active) {
          setError(
            err?.response?.data?.detail ||
              "This page could not be found."
          );
        }
      } finally {
        if (active) {
          setLoading(false);
        }
      }
    };

    if (slug) {
      loadPage();
    }

    return () => {
      active = false;
    };
  }, [slug]);

  if (loading) {
    return (
      <div style={{ padding: "80px 20px", textAlign: "center" }}>
        Loading...
      </div>
    );
  }

  if (error || !page) {
    return (
      <div style={{ padding: "80px 20px", textAlign: "center" }}>
        <h1>Page Not Found</h1>
        <p>{error || "The requested page does not exist."}</p>
      </div>
    );
  }

  return (
    <main
      style={{
        maxWidth: "1100px",
        margin: "0 auto",
        padding: "60px 24px",
        minHeight: "60vh",
      }}
    >
      <h1
        style={{
          fontSize: "36px",
          fontWeight: 700,
          marginBottom: "30px",
        }}
      >
        {page.title}
      </h1>

      <div
        style={{
          fontSize: "17px",
          lineHeight: 1.8,
          color: "#374151",
        }}
        dangerouslySetInnerHTML={{ __html: page.content || "" }}
      />
    </main>
  );
}
